export default "__VITE_ASSET__nwevF2cz__"